// @flow
function upcase(str: string): string {
  return `${str[0].toUpperCase()}${str.slice(1)}`;
}

export { upcase };
